import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';

import Footer from '../components/Footer';
import MapSearch from '../components/MapSearch';
import PageCounterNew from '../components/PageCounterNew';

import FechPostTrainerBySearch from "../fechData/FechPostTrainerBySearch";

import ParseLinkToArray from "../utils/ParseLinkToArray"
import queryString from 'query-string'

import DateTimeNow from "../utils/DateTimeNow";

const AdverbTrainerShort = React.lazy(() => import('../components/AdverbTrainerShort'));

class TrainersPage extends React.Component {

  searchTrainerItem = {
    page: ''
  };
  urlDeafulValues = [];
  urlValue = "";

  state = {
    title: "Trenerzy - RezerwujKort.pl",
    logInfo: "LogDebug __" + DateTimeNow() + "__ TrainersPage ",
    rowsCount: "6",
    restTrainerAdverbsData: {
      successful: false,
      status: '',
      message: '',
      data: []
    }
  }

  async componentDidMount() {

    document.title = this.state.title

    const { location: { search } } = this.props;
    this.state.search = search;
    this.urlValue = queryString.parse(this.state.search);

    this.searchTrainerItem = await ParseLinkToArray(this.urlValue, this.searchTrainerItem, this.urlDeafulValues);

    this.setState({
      restTrainerAdverbsData: await FechPostTrainerBySearch(this.searchTrainerItem)
    });
  }



  render() {

    var adverbs = "";
    if (this.state.restTrainerAdverbsData.successful &&
      typeof this.state.restTrainerAdverbsData.data.trainerResources.map === 'function') {
      adverbs = this.state.restTrainerAdverbsData.data.trainerResources.map(adverbOne =>
        <div>
          <Suspense fallback={<div>
            <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
          </div>}>
            <AdverbTrainerShort adverb={adverbOne} />
          </Suspense>
        </div>);
    }

    const urlValues = new Map();
    urlValues.set('page', "replace");

    var pageCounter = "";
    if (this.state.restTrainerAdverbsData.successful) {
      pageCounter = <PageCounterNew
        elementCount={this.state.restTrainerAdverbsData.data.totalRecordsCount}
        urlValues={urlValues}
        urlDeafulValues={this.urlDeafulValues}
        elementOnPage={this.state.rowsCount}
        currentPage={parseInt(this.searchTrainerItem.page) + 1}
        searchName={"trainers_search"}
        linkTo={"trenerzy"}
      />
    }

    return (
      <div>

        <Belt />

        <BeltLogged />

        <div id="content">
          <div class="container">
            <div class="main-subpage">
              <div class="head">

                <img src={`/images/login.png`} />
                <p>Trenerzy</p>
              </div>

              <MapSearch linkTo={"trainers_search"} />

              <div style={{ clear: 'both' }}>
                <div class="main-subpage-subtitle">Trenerzy</div>

                {adverbs}

              </div>

              <div >

                {pageCounter}

              </div>

            </div>

          </div>
        </div>

        <Footer />

      </div>
    );
  }
}

export default TrainersPage;
